import React, { useContext } from 'react';
import { useMediaQuery } from 'hooks';
import { SearchCategory } from '../SearchCategory';
import { useDiscountGroups, useInfoTitle, useRecentDiscount } from './hooks';
import * as S from './SearchList.styles';
import { HeaderContext } from '../HeaderContext';

export const SearchList = () => {
  const { mobile, tablet } = useMediaQuery();

  const { isSearchIncorrect } = useContext(HeaderContext);

  const infoTitle = useInfoTitle(isSearchIncorrect);

  const discountGroupByCategory = useDiscountGroups();

  const [recentSearch, recentTitle] = useRecentDiscount();

  const isRecentShown =
    !isSearchIncorrect && recentSearch && !discountGroupByCategory;
  return (
    <S.SearchList>
      {mobile || tablet ? (
        <S.TextTitle kind='h4' color='gray1'>
          {!infoTitle.titleHeader && `${infoTitle.description}`}
          {infoTitle.titleHeader &&
            `${infoTitle.titleHeader} ${infoTitle.description}`}
        </S.TextTitle>
      ) : (
        <>
          {infoTitle.titleHeader && (
            <>
              <S.TextTitle kind='h3' color='gray1'>
                {infoTitle.titleHeader}
              </S.TextTitle>
              {infoTitle.description && (
                <S.TextDescription kind='small1' color='gray1'>
                  {infoTitle.description}
                </S.TextDescription>
              )}
            </>
          )}
          {!infoTitle.titleHeader && (
            <S.TextDescription kind='h4' color='gray1'>
              {infoTitle.description}
            </S.TextDescription>
          )}
        </>
      )}
      <S.SearchListContent>
        {discountGroupByCategory &&
          !!Object.keys(discountGroupByCategory).length &&
          Object.keys(discountGroupByCategory).map((category) => (
            <SearchCategory
              title={category}
              items={discountGroupByCategory[category]}
              key={category}
            />
          ))}
      </S.SearchListContent>
      <S.SearchListContent>
        {isRecentShown && (
          <SearchCategory title={recentTitle} items={recentSearch} />
        )}
      </S.SearchListContent>
    </S.SearchList>
  );
};
